import { Lightning, Colors } from '@lightningjs/sdk';

export default class PlayButton extends Lightning.Component {
  static _template() {
    return {
      Border: {
        collision: true,
        zIndex: 4,
      },
    };
  }

  get _Border() {
    return this.tag('Border');
  }

  set name(val) {
    this._name = val;
  }

  _enable() {
    if (this._name == 'FilterButton') {
      this._Border.patch({
        texture: lng.Tools.getRoundRect(
          this.w,
          this.h,
          16,
          3,
          Colors('#000000').alpha(0).get(),
          false
        ),
      });
    } else {
      this._Border.patch({
        texture: lng.Tools.getRoundRect(this.w, this.h, 16, 3, Colors('#D6D6D6').get(), false),
      });
    }
  }

  _focus() {
    this._Border.patch({
      texture: lng.Tools.getRoundRect(this.w, this.h, 16, 3, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    if (this._name == 'FilterButton') {
      this._Border.patch({
        texture: lng.Tools.getRoundRect(
          this.w,
          this.h,
          16,
          3,
          Colors('#000000').alpha(0).get(),
          false
        ),
      });
    } else {
      this._Border.patch({
        texture: lng.Tools.getRoundRect(this.w, this.h, 16, 3, Colors('#D6D6D6').get(), false),
      });
    }
  }

  _handleHover() {
    if (this._name !== 'Subscription' || this._name !== 'Paid') {
      this.fireAncestors('$setState', this._name);
      this._focus();
    }
  }

  _handleUnhover() {
    if (this._name !== 'Subscription' || this._name !== 'Paid') {
      this._unfocus();
    }
  }

  _handleClick() {
    this.fireAncestors('$pressedClick');
  }
}
